export default __webpack_public_path__ + "static/francisktrunk2025-f10d27dbb6da06ddfb94b3f908f9fec4.jpg";